import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RoleService } from '../../services/role.service';

interface Filter {
  email: string;
  role: string;
}

@Component({
  selector: 'app-filter-user',
  templateUrl: './filter-user.component.html',
  styleUrls: []
})
export class FilterUserComponent implements OnInit {
  filter: Filter;
  public listRole = [];
  @Input() result: string = '';
  @Output() clicked = new EventEmitter<string>();

  constructor(private roleService: RoleService) { }

  ngOnInit() {
    this.filter = {
      email: '',
      role: '',
    };
    this.getRoles();
  }

  getRoles(): any {
    this.roleService.getAll()
      .subscribe(data => {
        this.listRole.push({ value: '', desc: 'Filtar por Rol' });
        data.forEach((rol) => {
          this.listRole.push({ value: rol.id, desc: rol.name });
        });
      });
  }

  onClick(searchTerm) {
    this.clicked.emit(searchTerm);
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/filter-user/filter-user.component.ts